<template>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
        <v-layout wrap>
            <v-flex xs6>
                <v-switch v-model="item.enable" label="Habilitado" color="success" inset />
            </v-flex>
            <v-flex xs6>
                <v-switch v-model="item.config.keepMaxPower" label="Manter potência máxima no plug" color="success" inset
                    hint="O plug recebe potência máxima ao conectar. O balanceamento reduz apenas se necessário. Em caso de falha, o plug permanece na potência máxima."
                    persistent-hint />
            </v-flex>
            <v-flex xs6>
                <v-text-field label="Nome" v-model="item.name" :rules="[rules.required]" />
            </v-flex>
            <v-flex xs6>
                <v-autocomplete v-model="item.server" :items="servers" item-value="id" item-text="name"
                    label="Integração no Servidor" :rules="[rules.required]" :disabled="item.id" @change="removeUnavailableChargers" />
            </v-flex>
            <v-flex xs6>
                <v-text-field v-model="item.config.maxPower" :rules="[rules.required, rules.range(1, 1000)]"
                    label="Potência máxima" suffix="kW" type="number" dense required />
            </v-flex>
            <v-flex xs12>
                <v-autocomplete v-model="item.config.chargers" :rules="[rules.required]" :items="filteredChargerList" item-value="name"
                    item-text="name" label="Carregadores" deletable-chips multiple small-chips :disabled="!item.server" />
            </v-flex>
            <v-flex xs12 v-if="excludedChargers.length">
                <v-alert type="error" dense>
                    Os seguintes carregadores foram removidos automaticamente por não estarem mais disponíveis no servidor selecionado: <br>
                    {{ excludedChargers.join(", ") }}
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-btn :loading="lock" :disabled="!valid" color="success" @click="validate"
                    style="width: 100%;">Salvar</v-btn>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";

import servers from "@/assets/json/servers.json";

export default {
    directives: { mask },

    props: {
        itemToEdit: {
            type: Object,
        },
        lock: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            chargerList: [],
            excludedChargers: [],
            chargersLoaded: false,
            itemClean: {
                name: "",
                server: null,
                config: {
                    chargers: [],
                    maxPower: null,
                    keepMaxPower: true,
                },
                enable: true,
            },
            item: { ...this.itemClean },
            servers,
        };
    },

    mounted() {
        this.$http
            .get("api/v2/charger")
            .then((result) => {
                this.chargerList = result;
                this.chargersLoaded = true;
                this.removeUnavailableChargers();
            })
            .catch(() => {
                this.chargerList = [];
                this.chargersLoaded = true;
                this.removeUnavailableChargers();
            });
    },

    watch: {
        itemToEdit: {
            immediate: true,
            handler(newVal) {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }

                if (newVal == null) {
                    this.item = { ...this.itemClean };
                    this.excludedChargers = [];
                } else {
                    this.item = { ...newVal };
                    if (!this.item.config) {
                        this.item.config = { chargers: [], maxPower: null };
                    }
                    if (!Array.isArray(this.item.config.chargers)) {
                        this.item.config.chargers = [];
                    }
                    this.excludedChargers = [];
                    this.removeUnavailableChargers();
                }
            },
        },
    },

    computed: {
        filteredChargerList() {
            if (!this.item.server) return this.chargerList;
            return this.chargerList.filter((c) => c.server === this.item.server);
        },
    },

    methods: {
        removeUnavailableChargers() {
            if (!this.chargersLoaded || !this.item || !this.item.config) return;

            const selectedChargers = Array.isArray(this.item.config.chargers)
                ? this.item.config.chargers
                : [];

            if (!selectedChargers.length) {
                this.excludedChargers = [];
                return;
            }

            const availableNames = new Set(this.filteredChargerList.map((charger) => charger.name));
            const validChargers = selectedChargers.filter((name) => availableNames.has(name));
            const removedChargers = selectedChargers.filter((name) => !availableNames.has(name));

            this.item.config.chargers = validChargers;
            this.excludedChargers = removedChargers;
        },

        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("save", this.item);
            }
        },
    },
};
</script>